import type { ComponentPropsWithRef } from "react";

import { cn } from "@/lib/utils";

type ProductListHeaderProps = ComponentPropsWithRef<"header">;

const ProductListHeader = ({
  className,
  children,
  ...props
}: ProductListHeaderProps) => {
  if (!children) return null;

  return (
    <header
      className={cn(
        "flex items-start justify-between gap-4 p-4 text-lg tracking-wide",
        className,
      )}
      {...props}
    >
      {children}
    </header>
  );
};

ProductListHeader.displayName = "ProductListHeader";

export default ProductListHeader;
